"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { useLocaleRouter } from "@/hooks/useLocaleRouter";
import { Title, Text } from "@/components/ui/Headings";

const ShortIntroSection: React.FC = () => {
  const { t } = useTranslation();
  const { createLocalizedPath } = useLocaleRouter();
  return (
    <section className="py-4 sm:py-6 lg:py-7 bg-primary-100">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-2 sm:gap-4 lg:gap-6">
        <Title size="md" className="leading-tight">
          {t("home.intro.heading")}
        </Title>
        <Text
          variant="body"
          className="text-gray-700 leading-relaxed max-w-3xl"
        >
          {t("home.intro.body")}
        </Text>
        <Link
          href={createLocalizedPath("/about")}
          className="inline-flex items-center text-primary-600 font-semibold text-xs sm:text-sm hover:text-primary-700 transition-colors group touch-target"
        >
          {t("home.intro.cta")}
          <ArrowRight className="ml-2 h-5 w-5 sm:h-6 sm:w-6 transform group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
};

export default ShortIntroSection;
